import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import classNames from "classnames";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import styled from "styled-components";

import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../../../components/Text";

import {
  getCollectionList,
  getImageBanner,
  getCollectionPrefix
} from "../../../actions/kafairAction";

import { normalizeBrand } from "../../../utils/Helpers";
import { getCloudImageUrl, emptyImage } from "../../../utils";

import RaffleSection from "./RaffleSection";

import FanImg from "../../../images/kipas.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";
import eventBackgroundImg from "../../../images/event_background.jpeg";

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const ProductItem = ({ item, brand, category, img }) => {
  return (
    <a
      href={`/${category}/${item.id}/${item.slug}`}
      title={item.display_name}
      key={item.id}
      className="sneaker-item"
    >
      <Col md={4} xs={12}>
        <div
          className={classNames("product-card", {
            disabled: !item.price || item.out_of_stock
          })}
        >
          <div
            className={classNames("sneaker-item__text", {
              disabled: !item.price || item.out_of_stock
            })}
          >
            <p>{brand ? normalizeBrand(brand) : null}</p>
            <p>{item.display_name}</p>
          </div>
          <KickImage
            alt={item.display_name}
            src={img}
            className={classNames("sneaker-item__image", {
              disabled: !item.price || item.out_of_stock
            })}
          />
          {item.price ? (
            <TextRupiah
              value={item.price}
              className="price-tag"
              color="black"
              bold={true}
              align="center"
            />
          ) : (
            <span className="text-center">X</span>
          )}
        </div>
      </Col>
    </a>
  );
};

class SpecialDeals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      category: "sneakers",
      page: 1,
      slug: this.props.slug,
      name: this.props.name,
      newSlug: "",
      collectionNotFound: false
    };
    this.tabs = [
      {
        heading: "Sneakers",
        category: "sneakers"
      },
      {
        heading: "Apparel",
        category: "apparels"
      },
      {
        heading: "Handbags",
        category: "handbags"
      }
    ];
  }

  async componentDidMount() {
    const { category, page, slug, name } = this.state;
    const { hideSpecialDeals } = this.props;

    const payloadPrefix = {
      prefix_slug: slug,
      limited_time: true
    };

    const payload = {
      page,
      per_page: 16,
      pre_verified: true
    };

    if (!hideSpecialDeals) {
      const dataPrefix = await this.props.getCollectionPrefix(
        payloadPrefix,
        name
      );

      if (
        dataPrefix.value &&
        dataPrefix.value.data &&
        dataPrefix.value.data.data.length > 0
      ) {
        const newSlug = dataPrefix.value.data.data[0].slug;

        this.props.getCollectionList("all", newSlug, payload, name);
        this.props.getImageBanner(newSlug, name);
        this.setState({
          collectionNotFound: false,
          newSlug
        });
      } else {
        this.setState({
          collectionNotFound: true
        });
      }
    }
  }

  renderProducts = () => {
    const { category, name } = this.state;
    const {
      data: {
        [name]: {
          products: { data },
          expiry,
          starts_at
        }
      }
    } = this.props;

    const isStart = moment().isAfter(starts_at);

    return (
      <div>
        {data.length > 0 ? (
          <Thumbnails
            settings={previewSettings}
            afterChange={this.changeImage}
            beforeChange={this._handleBeforeChange}
            thumbnails={data.map(item => {
              return {
                id: item.id,
                slug: item.slug,
                img: item.product_variant_images.length
                  ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
                  : emptyImage(category),
                display_name: item.display_name,
                brand:
                  item.product &&
                  item.product.brand &&
                  item.product.brand.flat[0],
                price: item.price,
                out_of_stock: item.out_of_stock,
                category
              };
            })}
            active={this.state.currentIndex}
            renderItems={data => this.renderItems(category, data, isStart)}
          />
        ) : null}
      </div>
    );
  };

  renderItems = (category, data, isStart) => {
    return data.map((item, index) => (
      <a
        href={`/${category}/${item.id}/${item.slug}`}
        title={item.display_name}
        key={index}
        className="sneaker-item"
        style={
          !item.price || item.out_of_stock || !isStart
            ? {
              pointerEvents: "none"
            }
            : {}
        }
      >
        <div className={classNames("product-card")}>
          <div
            className={classNames("sneaker-item__text", {
              disabled: !item.price || item.out_of_stock || !isStart
            })}
          >
            <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
            <p>{item.display_name}</p>
          </div>
          <KickImage
            alt={item.display_name}
            src={item.img}
            className={classNames("sneaker-item__image", {
              disabled: !item.price || item.out_of_stock || !isStart
            })}
          />
          {item.price ? (
            <TextRupiah
              value={item.price}
              className="price-tag"
              color="black"
              bold={true}
              align="center"
              disabled={!item.price || item.out_of_stock || !isStart}
            />
          ) : (
            <span className="text-center">X</span>
          )}
        </div>
      </a>
    ));
  };

  goToProductList = () => {
    const { name } = this.state;
    const {
      data: {
        [name]: { slug }
      }
    } = this.props;

    this.props.history.push({
      pathname: `/kafair/special-deals`,
      state: { slug, name }
    });
  };

  renderTimer = ({ days, hours, minutes, seconds, completed }) => {
    const { name } = this.state;

    if (completed) {
      return (
        <div
          className={classNames("countdown-wrapper", {
            purple: name === "special_deals_capsule"
          })}
        >
          <span>{zeroPad(days)}</span>
          <span>:</span>
          <span>{zeroPad(hours)}</span>
          <span>:</span>
          <span>{zeroPad(minutes)}</span>
          <span>:</span>
          <span>{zeroPad(seconds)}</span>
        </div>
      );
    } else {
      return (
        <div
          className={classNames("countdown-wrapper", {
            purple: name === "special_deals_capsule"
          })}
        >
          <span>{zeroPad(days)}</span>
          <span>:</span>
          <span>{zeroPad(hours)}</span>
          <span>:</span>
          <span>{zeroPad(minutes)}</span>
          <span>:</span>
          <span>{zeroPad(seconds)}</span>
        </div>
      );
    }
  };

  render() {
    const { category, name, collectionNotFound } = this.state;
    const {
      raffle,
      hideSpecialDeals,
      data: {
        [name]: {
          title,
          isActive,
          isFetching,
          expiry,
          starts_at,
          products,
          kafair: { imagesLandscape }
        }
      }
    } = this.props;

    const bacground_img = imagesLandscape || eventBackgroundImg;

    const isStart = moment().isAfter(starts_at);
    const isExpired = moment().isAfter(expiry);

    const isRaffleNotActive =
      !raffle ||
      !raffle.start_date ||
      !raffle.expiry ||
      moment().isAfter(raffle.expiry);

    const isSpecialDealsNotActive =
      isFetching || !isActive || collectionNotFound;

    if (isSpecialDealsNotActive && isRaffleNotActive) return null;

    return (
      <Container
        fluid
        className={classNames(
          "special-deals-section",
          {
            "with-raffle":
              raffle && !hideSpecialDeals && !isSpecialDealsNotActive
          },
          {
            "raffle-only":
              raffle && (hideSpecialDeals || isSpecialDealsNotActive)
          }
        )}
      >
        <KickImage src={bacground_img} className={classNames("img-background")} />
        {raffle && !isRaffleNotActive && (
          <RaffleSection
            title={raffle.title}
            products={raffle.products}
            isGolden={raffle.golden}
            start_date={raffle.start_date}
            expiry_date={raffle.expiry}
            ticket_name={raffle.ticket_name}
            title={raffle.title}
            color={raffle.color}
            group_name={raffle.group_name}
            key={raffle.key}
            ticket_type={raffle.ticket_type}
            history={this.props.history}
          />
        )}
        {!hideSpecialDeals && !isSpecialDealsNotActive && (
          <Row
            className={classNames(
              `content-container ${raffle && raffle.ticket_name
                ? raffle.ticket_name.toLowerCase()
                : ""
              }`
            )}
          >
            <Col md={3} xs={12}>
              <div className="left-side">
                <div className="timer-wrapper">
                  <span>{isStart ? "Berakhir dalam" : "Mulai dalam"}</span>
                  <Countdown
                    date={
                      isStart
                        ? moment(expiry).toISOString()
                        : moment(starts_at).toISOString()
                    }
                    daysInHours={true}
                    zeroPadTime={2}
                    renderer={this.renderTimer}
                  />
                </div>
                <span className="title">{title}</span>
                <span className="title sub">
                  Find out big discounted hype items here!
                </span>
                <div
                  className={classNames("see-all-button d-none d-sm-block", {
                    purple: name === "special_deals_capsule"
                  })}
                  onClick={this.goToProductList}
                >
                  <span>VIEW SPECIAL DEALS</span>
                </div>
              </div>
            </Col>
            <Col md={9} xs={12}>
              <div className="right-side">{this.renderProducts()}</div>
              <div className="button-wrapper d-block d-sm-none">
                <div
                  className={classNames("see-all-button", {
                    purple: name === "special_deals_capsule"
                  })}
                  onClick={this.goToProductList}
                >
                  <span>VIEW SPECIAL DEALS</span>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dataKaFair
});

const mapDispatchToProps = dispatch => ({
  getCollectionPrefix: (payload, name) =>
    dispatch(getCollectionPrefix(payload, name)),
  getCollectionList: (category, slug, payload, name) =>
    dispatch(getCollectionList(category, slug, payload, name)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name))
});

export default connect(mapStateToProps, mapDispatchToProps)(SpecialDeals);
